import { render, staticRenderFns } from "./LayoutAplication.vue?vue&type=template&id=51cbc835&"
import script from "./LayoutAplication.vue?vue&type=script&lang=js&"
export * from "./LayoutAplication.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAplication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports